import React from 'react'
import { FaImage } from 'react-icons/fa'

/**
 * Reusable image placeholder for images to be added later.
 * @param {string} height  - CSS height value (e.g. "300px")
 * @param {string} label   - Optional descriptive label
 * @param {string} ratioClass - Optional Bootstrap aspect ratio class (e.g. "ratio-16x9")
 */
export default function ImagePlaceholder({ height = '300px', label = 'Imagem', ratioClass }) {
  const inner = (
    <div
      className="img-placeholder w-100"
      style={ratioClass ? { height: '100%' } : { height }}
    >
      <FaImage size={36} />
      <span>{label}</span>
    </div>
  )

  if (ratioClass) {
    return <div className={`ratio ${ratioClass}`}>{inner}</div>
  }

  return inner
}
